/* template */
<template minapp="mpx" xlang="wxml"><div class="es-calendar-month"><div class="es-calendar-month__title">{{ title }}</div><div class="es-calendar-month__days"><mpx-view v-for="(item, index) in (days)" :key="item.index" :style="[(activeColor)] | transRpxStyle" :class='("es-calendar-month__day "+(item.isToday && "is-today")+" "+(item.type && "is-"+ item.type))' @tap="onClick(index,$event)"><div class="popover-calendar-wapper" v-if="(type === 'range' && item.type && item.type === 'end' && showPop)"><div class="arrow-calendar"></div><div class="popover-calendar">{{ nightNum }}晚</div></div><span :class='("es-calendar-month__topText "+(item.holidayType))' v-if="(item.holiday)">{{ item.holiday }}</span><span class="es-calendar-month__text">{{ item.text }}</span><span class="es-calendar-month__subText" v-if="(item.subText)">{{ item.subText }}</span></mpx-view></div></div></template>

/* styles */
<style lang="stylus" src="./month.styl" scoped mpxStyleOptions='{"mid":"m12312fcc"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m12312fcc"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./month.mpx.js?isComponent&outputPath=components%2Fmonth12312fcc%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./month.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fmonth12312fcc%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m12312fcc"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/month12312fcc/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
